module.exports = __webpack_public_path__ + "img/map_jaboatao.0cc71f22.png";